import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { FounderSection } from './components/FounderSection';
import { ActivitiesSection } from './components/ActivitiesSection';
import { EducationSection } from './components/EducationSection';
import { CommunitySection } from './components/CommunitySection';
import { PlayerRightsSection } from './components/PlayerRightsSection';
import { NewsSection } from './components/NewsSection';
import { PartnersSection } from './components/PartnersSection';
import { DisclaimerSection } from './components/DisclaimerSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    fetch('https://ipapi.co/json/').then(res => res.json()).then(data => {
      if (data.country_code && data.country_code === 'UA') {
        window.location.href = 'https://fgsu.org';
      }
    }).catch(() => {
      // If geo-detection fails, keep user on current site
    });
  }, []);
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <MissionSection data-id="element-4" />
        <FounderSection data-id="element-5" />
        <ActivitiesSection data-id="element-6" />
        <EducationSection data-id="element-7" />
        <CommunitySection data-id="element-8" />
        <PlayerRightsSection data-id="element-9" />
        <NewsSection data-id="element-10" />
        <DisclaimerSection data-id="element-11" />
        <PartnersSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}